import { SwitchProps, Switch as S, Box } from 'theme-ui';
import { getVariant } from '../util/getVariant';
import { forwardRef } from 'react';

export const Switch = forwardRef<any, SwitchProps>((props, ref) => (
  <Box
    {...getVariant('layout.common.components.switchBase')}
    className="apia__switch"
  >
    <S {...props} ref={ref} />
  </Box>
));
